import React from "react";
import { Badge, Flex, Text } from "@chakra-ui/react";

export default function FiltrosAplicadosChips({ chips }) {
  if (!chips || chips.length === 0) {
    return (
      <Text color="#6B6C71" fontSize="14px">
        Nenhum filtro foi aplicado nesta pesquisa.
      </Text>
    );
  }

  return (
    <Flex flexWrap="wrap" gap={2}>
      {chips.map((chip, i) => (
        <Badge
          key={i}
          backgroundColor="#EBF3F2"
          color="#1E6164"
          border="1px solid #B5CEC8"
          borderRadius="20px"
          px="12px"
          py="4px"
          fontWeight={500}
          fontSize="13px"
          textTransform="none"
        >
          {chip.label}: {chip.value}
        </Badge>
      ))}
    </Flex>
  );
}
